import React from "react";

function UnLike({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8232 7.5625C15.1045 8.03125 15.2607 8.5 15.2607 9.125C15.2607 10.5 14.0732 11.7812 12.5732 11.7812H11.417C11.5732 12.1875 11.6982 12.6562 11.6982 13.25C11.6982 15.5312 10.5107 16.5 8.72949 16.5C6.79199 16.5 6.91699 13.5625 6.47949 13.125C5.76074 12.4062 4.91699 11.0312 4.32324 10.5H4.10449C3.94824 10.8125 3.60449 11 3.26074 11H1.26074C0.698242 11 0.260742 10.5625 0.260742 10V2.5C0.260742 1.96875 0.698242 1.5 1.26074 1.5H3.26074C3.51074 1.5 3.72949 1.625 3.91699 1.75H4.26074C5.51074 1.75 6.54199 0.53125 9.76074 0.53125C10.0107 0.53125 10.2607 0.5 10.4795 0.5C12.8857 0.5 13.9482 1.75 13.9795 3.5C14.417 4.0625 14.6357 4.84375 14.542 5.59375C14.8545 6.15625 14.9482 6.84375 14.8232 7.5625ZM2.26074 9.75C2.66699 9.75 3.01074 9.4375 3.01074 9C3.01074 8.59375 2.66699 8.25 2.26074 8.25C1.82324 8.25 1.51074 8.59375 1.51074 9C1.51074 9.4375 1.82324 9.75 2.26074 9.75ZM12.5732 10.2812C13.2295 10.2812 13.7295 9.6875 13.7607 9.09375C13.7607 8.53125 13.3545 7.9375 13.042 7.9375C13.4795 7.46875 13.5732 6.5 12.8857 5.875C13.292 5.21875 12.917 4.34375 12.4482 4.0625C12.6982 2.5625 11.8857 2.03125 10.792 2.03125H9.60449C7.38574 2.03125 5.91699 3.1875 4.26074 3.1875V9H4.57324C5.47949 9 6.69824 11.2188 7.54199 12.0625C8.41699 12.9375 8.13574 14.4375 8.72949 15C10.1982 15 10.1982 14 10.1982 13.25C10.1982 12.0312 9.32324 11.4688 9.32324 10.2812H12.5732Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default UnLike;
